import { layers } from '@atlassian/jira-common-styles/src/main.tsx';

/**
 * Rendering a `<Select>` in a `<Modal>` results in the select options getting cut off by the bottom of the modal and
 * scrolling. This is a work-around for that, see https://atlassian.slack.com/archives/CFJ9DU39U/p1623179496484100
 */
export const selectInAModalStyleFixProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	styles: { menuPortal: (base: any) => ({ ...base, zIndex: layers.modal + 1 }) },

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	menuPortalTarget: document.body,
};

export const textAreaAttributeProps = {
	minimumRows: 4,
	maxHeight: '400px',
};
